import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import LinearProgress from "@material-ui/core/LinearProgress";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import { Theme, withStyles, WithStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import * as React from "react";
import CopyButton from "../../components/CopyButton";
import Modal, { IModalProps } from "../../components/Modal";
import withAppContext, {
  IAppContextProps,
} from "../../components/withAppContext";
import resolveUri from "../../resolveUri";

import { ISport, ISurveyResponse, TemplateType } from "src/services";
import { withSchoolContext } from "../DirectorPage";
import IDirectorPageProps from "./IDirectorPageProps";
import { Box } from "@material-ui/core";

const styles = (theme: Theme) => ({
  button: {
    marginLeft: theme.spacing(1),
  },
  copy: {
    marginTop: theme.spacing(1),
  },
  list: {
    height: "20em",
    overflow: "scroll",
  },
  listItem: {
    "&:hover": {
      backgroundColor: theme.palette.secondary.main,
    },
    backgroundColor: "white",
  },
  root: {
    backgroundColor: theme.palette.primary.main,
  },
  sendEvalModal: {
    height: "35em",
  },
});

// const MIN_PAGE = 0;
const MAX_PAGE = 1;

interface IExtraProps {
  surveyResponse?: ISurveyResponse;
  startEvaluation?: (sport: ISport) => void;
  resetState?: () => void;
  startEvaluationSubmitting?: true;
  route:any

}

interface IBaseProps extends IModalProps, IExtraProps {
  closeModal: (...args: any[]) => void;
    schoolData?:any;
}

type IProps = IBaseProps &
  IDirectorPageProps &
  WithStyles<keyof ReturnType<typeof styles>> &
  IAppContextProps;

interface ISendEvalModalState {
  page: number;
  evalSport?: ISport;
}

export default withSchoolContext<IBaseProps>(
  withAppContext(
    withStyles(styles)(
      class SendEvalModalClass extends React.Component<
        IProps,
        ISendEvalModalState
      > {
        public static defaultProps = {
          surveyResponse: undefined,
        };

        constructor(props: IProps) {
          super(props);
          this.state = {
            page: 0,
          };
        }

        public componentWillReceiveProps(nextProps: IProps) {
          if (nextProps.surveyResponse !== undefined) {
            this.setState({ page: 1 });
          }
        }


        public getAddonsID() {
          let addonIDs: any = []
          if (Object.keys(this.props?.userSubscription).length > 0) {
            if (this.props?.userSubscription?.addon?.length > 0) {
              addonIDs = this.props?.userSubscription?.addon.map((item: any) => Number(item?.addon?.id))
            }
          }
          let isEnable = true
          if (Object?.keys(this.props.userSubscription).length > 0) {
            console.log("this.props.userSubscription?.plan?.id===4||this.props.userSubscription?.plan?.id===5",this.props)
            if(this.props.userSubscription?.plans?.id===4||this.props.userSubscription?.plans?.id===5){
              isEnable = false
            }else if(addonIDs.includes(2)){
              isEnable = false
            } else{
            isEnable = true
           }
  
          } else {
            isEnable = true
          }
          return isEnable
          // return Object?.keys(this.props.userSubscription).length > 0 ? (this.props.userSubscription?.plans?.id !== 4&&this.props.userSubscription?.plans?.id !== 5) ? addonIDs.includes(2) ? false : true : false : false
        }
        public render() {
          const { classes, open } = this.props;
          const { page } = this.state;
          return (
            <Modal
              className={classes.sendEvalModal}
              open={open}
              closeModal={this.handleCloseModal}
            >
              <Box
                display="flex"
                flexDirection="column"
                height="100%"
                justifyContent="space-between"
              >
                {this.renderPage(page)}
                <Button onClick={this.handleCloseModal} variant="contained">
                  Close
                </Button>
                {this.renderStepButtons()}
              </Box>
            </Modal>
          );
        }

        private renderStepButtons() {
          const { classes } = this.props;
          const { page, evalSport } = this.state;
          const { surveyResponse } = this.props;
          if (surveyResponse === undefined) {
            return (
              <Grid container={true} justifyContent="flex-end">
                <Button
                  color="primary"
                  onClick={this.handleNext}
                  variant="contained"
                  disabled={page >= MAX_PAGE || evalSport === undefined}
                  className={classes.button}
                >
                  Start Survey
                </Button>
              </Grid>
            );
          }
          return null;
        }

        private renderPage(page: number) {
          switch (page) {
            case 0:
              return this.renderFirstPage();
            case 1:
              return this.renderSecondPage();
            default:
              return this.renderFirstPage();
          }
        }

        private renderFirstPage() {
          const { sports, classes, surveys, coaches } = this.props;
          const { evalSport } = this.state;
          return (

            <div className="sendEvaluation evaluatoinsent">
              <Grid>
                <Typography variant="h3" style={{ fontSize: "2.5rem" }}>
                  Send Surveys
                </Typography>
                <Typography variant="body1">
                  Pick a sport and then start the survey
                </Typography>
                <List className={classes.list}>
                  {sports.map((sport) => {
                    const sportSurvey = surveys.find(
                      (survey) => survey.sportId === sport.id
                    );
                    // See if we have any coahes with this sport listed, otherwise, it would be pointless to send eval
                    const coach = coaches.find(
                      (c) => c.sports.find((s) => s.id === sport.id) !== undefined
                    );
                    // Make sure we filter out surveys that haven't yet completed
                    if (
                      (sportSurvey !== undefined &&
                        sportSurvey.responseCollectionEndDate === null) ||
                      coach === undefined
                    ) {
                      return null;
                    }
                    return (
                      <ListItem
                        classes={{
                          root:
                            evalSport === undefined
                              ? undefined
                              : evalSport.name === sport.name
                                ? classes.root
                                : undefined,
                        }}
                        // className={classes.listItem} /// NOTE: use this for theme colors. LOL cute but tacky.
                        button={true}
                        divider={true}
                        key={sport.id}
                        onClick={this.handleSportsChange(sport)}
                      >
                        <ListItemText primary={`${sport.name}`} />
                      </ListItem>
                    );
                  })}
                </List>
              </Grid>
            </div>

          );
        }

        private renderSecondPage() {
          console.log("schoolData in SendEvalModal:", this.props.schoolData);
          console.log("isAdsurvey in SendEvalModal:", this.props.schoolData?.isAdsurvey);
          const {
            appContext: { baseUri },
            startEvaluationSubmitting,
            classes,
            surveyResponse,
          } = this.props;
          if (surveyResponse !== undefined) {
            const studentLink = resolveUri(
              `${baseUri}/student/${encodeURIComponent(
                surveyResponse.survey.studentCode
              )}`
            );
            const coachLink = resolveUri(
              `${baseUri}/coach/${encodeURIComponent(
                surveyResponse.survey.coachCode
              )}`
            );
            const parentLink = resolveUri(
              `${baseUri}/parent/${encodeURIComponent(
                surveyResponse.survey.parentCode
              )}`
            );
            return (
              <div className="sendEvaluation evaluatoinsent">

                <Grid>
                  <Typography variant="h4" style={{ fontSize: "2.5rem" }}>
                    Send Surveys
                  </Typography>
                  <Typography variant="body1">
                  Copy the link below and send it to the appropriate group.
                  </Typography>
                  <br />
                  <Typography variant="h5">Survey for {this.props.schoolData?.isAdSurvey ? "Coaches" : "Students"}</Typography>
                  <Typography variant="body1">
                    Send this link to {this.props.schoolData?.isAdSurvey ? "coach" : "student"} athletes on any team you would like
                    to survey.
                  </Typography>
                  <Grid
                    container={true}
                    direction="row"
                    justifyContent="center"
                    className={classes.copy}
                  >
                    <CopyButton link={studentLink} disableParent={false} isStarterPlan={false} route={""}/>
                  </Grid>
                  <br />
                  {surveyResponse.survey.type !== TemplateType.noGridNoCoach ? (
                    <>
                      <Typography variant="h5">
  {this.props.schoolData?.isAdSurvey ? "Survey for AD" : "Survey for Coaches"}
</Typography>
<Typography variant="body1">
  Send this link to the {this.props.schoolData?.isAdSurvey ? "AD" : "coach"} to perform a self-survey.
</Typography>
                      <Grid
                        container={true}
                        direction="row"
                        justifyContent="center"
                        className={classes.copy}
                      >
                        <CopyButton link={coachLink} disableParent={false} isStarterPlan={false} route={""} />
                      </Grid>
                    </>
                  ) : null}
                  <br />
                  {surveyResponse.survey.enableParentQuestions ? (
                    <>
                      <Typography variant="h5">Survey for Parents</Typography>
                      <Typography variant="body1">
                        If parent surveys are enabled, please send them from
                        here.
                      </Typography>
                      <Grid
                        container={true}
                        direction="row"
                        justifyContent="center"
                        className={classes.copy}
                      >
                        <CopyButton link={parentLink} disableParent={this.getAddonsID()}   isStarterPlan={this.props?.userSubscription?.plans?.id===1?true:false} route={this.props.route} />
                      </Grid>
                    </>
                  ) : null}
                </Grid>
              </div>
            );
          }
          if (startEvaluationSubmitting) {
            return <LinearProgress />;
          }
          return (
            <span>
              Something went wrong generating the links. Please close the
              light-box and try again.
            </span>
          );
        }

        private readonly handleNext = () => {
          const { startEvaluation } = this.props;
          const { evalSport } = this.state;
          this.setState({ page: this.state.page + 1 });
          if (startEvaluation !== undefined && evalSport !== undefined) {
            startEvaluation(evalSport);
          }
        };

        private readonly handleSportsChange =
          (sport: ISport) => (e: React.ChangeEvent<any>) =>
            this.setState({ evalSport: sport });

        private readonly handleCloseModal = () => {
          const { closeModal, resetState } = this.props;
          closeModal();
          if (resetState !== undefined) {
            resetState();
          }
          this.setState({ evalSport: undefined, page: 0 });
        };
      }
    )
  )
);



// WEBPACK FOOTER //
// ./src/pages/director/SendEvalModal.tsx